import {Field, ErrorMessage, useField  } from "formik";
import ErrorText from "./ErrorText";
import { propsInputText } from "./FormElementos.Model.d";

export default function InputText(props: propsInputText){    
    const [field, meta] = useField(props.name);  
    return (
      <div >
          {(props.label) && <label htmlFor={props.name}>{props.label}</label> }
          <Field className={`${props.clase} ${meta.touched && meta.error && 'is-invalid'}`} {...props} />
          <ErrorMessage name={field.name}>{ mensaje => 
              <ErrorText mensaje={mensaje} />
          }</ErrorMessage>
      </div>
    )
  }
  